import { render, staticRenderFns } from "./SupporterViewPhones.vue?vue&type=template&id=03ce8601&"
import script from "./SupporterViewPhones.vue?vue&type=script&lang=js&"
export * from "./SupporterViewPhones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03ce8601')) {
      api.createRecord('03ce8601', component.options)
    } else {
      api.reload('03ce8601', component.options)
    }
    module.hot.accept("./SupporterViewPhones.vue?vue&type=template&id=03ce8601&", function () {
      api.rerender('03ce8601', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supporters/views/Details/SupporterViewPhones.vue"
export default component.exports